import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary via-secondary to-accent text-white py-12">
        <div className="container mx-auto px-4">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="mb-4 text-white hover:bg-white/20"
          >
            <ArrowLeft className="mr-2 w-4 h-4" />
            Zurück zur Startseite / Back to Home
          </Button>
          <div className="flex items-center gap-3">
            <FileText className="w-8 h-8" />
            <h1 className="text-4xl font-serif font-bold">Impressum / Legal Notice</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* German Version */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6">Impressum (Deutsch)</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-2">Angaben gemäß § 5 TMG</h3>
                <p>
                  <strong>Manfred Hahnel</strong><br />
                  Quetschnmanfred<br />
                  München, Bayern<br />
                  Deutschland
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Kontakt</h3>
                <p>
                  Telefon: <a href="tel:+491749525375" className="text-primary hover:underline">+49 174 9525 375</a><br />
                  E-Mail: <a href="mailto:quetschnmanfred@gmail.com" className="text-primary hover:underline">quetschnmanfred@gmail.com</a><br />
                  WhatsApp: <a href="https://wa.me/491749525375" className="text-primary hover:underline">+49 174 9525 375</a>
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Umsatzsteuer-ID</h3>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                  <em className="text-muted-foreground">[Bitte ergänzen Sie hier Ihre USt-IdNr., falls vorhanden]</em>
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
                <p>
                  Manfred Hahnel<br />
                  München, Bayern
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">EU-Streitschlichtung</h3>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline ml-1">
                    https://ec.europa.eu/consumers/odr
                  </a>
                  <br />
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h3>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Haftung für Inhalte</h3>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                  allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
                  verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
                  zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                  Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
                  Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Urheberrecht</h3>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
                  Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
                  Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </section>

          {/* English Version */}
          <section className="mt-12 pt-12 border-t-2">
            <h2 className="text-2xl font-bold mb-6">Legal Notice (English)</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-2">Information according to § 5 TMG</h3>
                <p>
                  <strong>Manfred Hahnel</strong><br />
                  Quetschnmanfred<br />
                  Munich, Bavaria<br />
                  Germany
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Contact</h3>
                <p>
                  Phone: <a href="tel:+491749525375" className="text-primary hover:underline">+49 174 9525 375</a><br />
                  Email: <a href="mailto:quetschnmanfred@gmail.com" className="text-primary hover:underline">quetschnmanfred@gmail.com</a><br />
                  WhatsApp: <a href="https://wa.me/491749525375" className="text-primary hover:underline">+49 174 9525 375</a>
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">VAT ID</h3>
                <p>
                  VAT identification number according to §27 a German VAT Tax Act:<br />
                  <em className="text-muted-foreground">[Please add your VAT ID here if applicable]</em>
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Responsible for content according to § 55 Abs. 2 RStV</h3>
                <p>
                  Manfred Hahnel<br />
                  Munich, Bavaria
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">EU Dispute Resolution</h3>
                <p>
                  The European Commission provides a platform for online dispute resolution (ODR): 
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline ml-1">
                    https://ec.europa.eu/consumers/odr
                  </a>
                  <br />
                  Our email address can be found above in the legal notice.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Consumer Dispute Resolution</h3>
                <p>
                  We are not willing or obliged to participate in dispute resolution proceedings before a consumer 
                  arbitration board.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Liability for Content</h3>
                <p>
                  As a service provider, we are responsible for our own content on these pages under § 7 para.1 TMG 
                  according to general laws. However, according to §§ 8 to 10 TMG, we are not obliged to monitor 
                  transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Liability for Links</h3>
                <p>
                  Our offer contains links to external third-party websites over whose content we have no influence. 
                  Therefore, we cannot assume any liability for this third-party content. The respective provider or 
                  operator of the pages is always responsible for the content of the linked pages.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-2">Copyright</h3>
                <p>
                  The content and works created by the site operators on these pages are subject to German copyright law. 
                  Duplication, processing, distribution, and any kind of exploitation outside the limits of copyright require 
                  the written consent of the respective author or creator.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
